import { render, staticRenderFns } from "./PhotoScroller.vue?vue&type=template&id=2d20a9ea&scoped=true&"
import script from "./PhotoScroller.vue?vue&type=script&lang=js&"
export * from "./PhotoScroller.vue?vue&type=script&lang=js&"
import style0 from "./PhotoScroller.vue?vue&type=style&index=0&id=2d20a9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20a9ea",
  null
  
)

component.options.__file = "PhotoScroller.vue"
export default component.exports